import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ENV_CONFIG } from '@ps/core-config';
import {
  SupplierResponseDto,
  SupplierAccessResponseDto,
} from './dtos/supplier.dto';
import { SupplierMapper } from './mappers/supplier.mapper';
import { SupplierAccessPayloadMapper } from './mappers/supplier-access.payload.mapper';
import { Supplier, SupplierAccessSave } from '../models/supplier.model';

@Injectable({ providedIn: 'root' })
export class SupplierApi {
  private readonly _http = inject(HttpClient);
  private readonly _envConfig = inject(ENV_CONFIG);
  private readonly _mapper = new SupplierMapper();
  private readonly _accessPayloadMapper = new SupplierAccessPayloadMapper();

  private readonly _baseUrl = this._envConfig.pureSpectrum.url;

  public getAll(buyerId: number): Observable<Supplier[]> {
    return this._http
      .get<SupplierResponseDto>(`${this._baseUrl}/getSupplier/${buyerId}`)
      .pipe(map((response) => this._mapper.fromDtoList(response.supplierList)));
  }

  public saveAccess(
    data: SupplierAccessSave,
  ): Observable<SupplierAccessResponseDto> {
    const payload = this._accessPayloadMapper.toPayload(data);
    return this._http.post<SupplierAccessResponseDto>(
      `${this._baseUrl}/preferedSupplierList`,
      payload,
    );
  }
}
